"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.referralAgreementSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const GenericValidator_1 = __importDefault(require("../../shared/validators/GenericValidator"));
exports.referralAgreementSchema = joi_1.default.object({
    orgKey: joi_1.default.string().required(),
    firstName: joi_1.default.string().optional(),
    lastName: joi_1.default.string().optional(),
    email: joi_1.default.string()
        .email({ tlds: { allow: false } })
        .required(),
    version: joi_1.default.string().required(),
});
class ReferralAgreementValidator extends GenericValidator_1.default {
    validate(input) {
        super.validate(input, 'IReferralAgreement', exports.referralAgreementSchema);
    }
}
exports.default = ReferralAgreementValidator;
